import { produce } from 'immer'

import { arrayToTree } from '../arrayToTree'
import { TreeNodes } from '../dnd-tree'

/**
 * Transform a flat array of nodes into a hierarchy structure
 * Also, as all nodes' props are into a data object, spreads it.
 * @param treeNodes
 */
export const convertTreeDataToDataSource = (treeNodes: TreeNodes) => {
    // step 1: add keys to props, and spreads the data into each node
    const treeDataWithkeys = treeNodes?.map((n) => {
        const newNode = produce(n, (nodeDraft) => {
            return {
                ...n,
                id: n.data.id,
                key: n.data.id,
            }
        })
        return newNode
    })

    // step 2: returns the tree hierarchy
    return arrayToTree(treeDataWithkeys, {
        id: 'id',
        parentId: 'data.parent',
        dataField: null,
        throwChildrenFieldIfEmpty: true,
    })
}
